// Parses the YYYY-MM-DD prefix of an ISO trial-end string into a local Date
// (timezone-agnostic, matching Caladan's getTrialMaxBookingDate). Returns
// null for missing input, malformed strings, or out-of-range fields like
// "2026-13-99" which JS Date would otherwise silently roll over.
export const parseTrialEndDate = (
  isoDateString: string | undefined,
): Date | null => {
  if (!isoDateString) {
    return null;
  }

  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(isoDateString);
  if (!match) {
    return null;
  }

  const [, yearStr, monthStr, dayStr] = match;
  const year = Number(yearStr);
  const month = Number(monthStr) - 1;
  const day = Number(dayStr);
  const localDate = new Date(year, month, day);

  if (Number.isNaN(localDate.getTime())) {
    return null;
  }

  // Round-trip guard: reject inputs whose fields don't survive Date's
  // overflow rollover (e.g. "2026-13-99" → April 2027).
  if (
    localDate.getFullYear() !== year ||
    localDate.getMonth() !== month ||
    localDate.getDate() !== day
  ) {
    return null;
  }

  return localDate;
};
